import * as React from 'react';
import style from './styles.scss';

export function Component() {
  return <div className={style.borderLayer}></div>;
}
